import ButtonSkeleton from '../../../../../../components/Button/skeleton';

const DurationCellSkeleton = () => {
  return <ButtonSkeleton />;
};

export default DurationCellSkeleton;
